<div class="featured-group" [class.featured-group--without-separator]="!showSeparator">
  <ng-content></ng-content>
</div>
